module.exports = __webpack_public_path__ + "static/origami-82737c341beb45015406f2a840882910.webp";